import React from 'react'
import { Table } from '@ztechapps/webui.data-tools'
import { ListRow } from './ListRow'
import { useRecentMessageContext } from './Context'
import { useMarkChatRead } from '@ztechapps/chat.common'
import type { ChatMessage } from '@ztechapps/common.contract'

export const List = () => {
  const { list, setSelectedChatMessage, height } = useRecentMessageContext()
  const [markChatRead] = useMarkChatRead()
  return (
    <Table
      dataArray={list}
      scrollable={true}
      height={height ?? '25vh'}
      row={ListRow}
      selectable={true}
      onSelect={async (item: ChatMessage) => {
        setSelectedChatMessage(item)
        if (item?.isUnread) {
          await markChatRead({ chatId: item?.chat?._id })
        }
      }}
    />
  )
}
